import hupassApi, { type SearchOption } from 'app/hupassApi';
import { atom } from 'recoil';

export const searchOptionsState = atom<SearchOption[]>({
  key: 'searchOptions',
  default: hupassApi.GetSearchOptions().then((res) => res.data),
});
